<template>
  <!-- 竖屏时 -->
  <div v-if="$store.state.app.isPortrait" class="wrap-poi-search-result">
    <!-- poi结果列表 -->
    <ul class="poi-list">
      <div class="popMarker-close" @click="$emit('close')">
        <i class="icon el-icon-circle-close popMarker-close-item"></i>
      </div>
      <li
        v-for="(item, index) in dataList"
        :key="index"
        class="poi-li"
        :class="dataIndex === index ? 'active' : ''"
        @click="changeIndex(item, index)"
      >
        <div class="poiName">
          <p>{{ item.name }}</p>
          <p>{{ floorMapping[item.floor] }} {{ item.distance.toFixed(2) }}米</p>
        </div>
        <img
          class="btn"
          src="/images/preloader/btn-gotohere.png"
          alt=""
          @click="gotoHere(item)"
        />
      </li>
    </ul>
  </div>
  <!-- 横屏时 -->
  <div v-else class="wrap-poi-search-result">
    <!-- poi结果列表 -->
    <ul class="poi-list">
      <li
        v-for="(item, index) in dataList"
        :key="index"
        class="poi-li"
        :class="dataIndex === index ? 'active' : ''"
        @click="changeIndex(item, index)"
      >
        <div class="number">{{ index + 1 }}</div>
        <div class="text">
          <div class="poiName">{{ item.name }}</div>
          <div class="poiInfo">
            {{ floorMapping[item.floor] }} {{ item.distance.toFixed(2) }}米
          </div>
        </div>
        <img
          class="btn"
          src="/images/preloader/btn-gotohere.png"
          alt=""
          @click="gotoHere(item)"
        />
      </li>
    </ul>
    <!-- 关闭按钮 -->
    <img
      class="btn-close"
      src="/images/preloader/btn-close.png"
      alt=""
      @click="$emit('close')"
    />
  </div>
</template>

<script>
import { getLocalStorage } from "@/utils/auth";
export default {
  components: {},
  props: {},
  data() {
    return {
      dataList: [],
      dataIndex: 0 // 当前选择数据下标
    };
  },
  computed: {
    // appid
    appid() {
      return this.$store.state.app.appid;
    },
    // 建筑信息
    buildInfo: {
      get() {
        return this.$store.state.nav.buildInfo;
      },
      set(val) {
        this.$store.commit("nav/set_buildInfo", val);
      }
    },
    // 地图楼层映射
    floorMapping() {
      return this.$store.getters["nav/floorMapping"];
    },
    // 地图当前聚焦楼层
    mapFocusFloor: {
      get() {
        return this.$store.state.nav.mapFocusFloor;
      },
      set(val) {
        this.$store.commit("nav/set_mapFocusFloor", val);
      }
    },
    // 当前选中的POI二维码
    curPoiQRcode: {
      get() {
        return this.$store.state.nav.curPoiQRcode;
      },
      set(val) {
        this.$store.commit("nav/set_curPoiQRcode", val);
      }
    },
    envCode() {
      return getLocalStorage("envCode") ? getLocalStorage("envCode") : "0";
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    async init(data) {
      console.log("接收的poi搜索结果数据：", data);
      this.dataList = data;
      let obj = { mpbt: this.buildInfo.buildType };
      if (Number(this.envCode) > 0) {
        obj.e = this.envCode;
      }
      let params = this.$utils.urlEncode(obj, false);
      const res = await this.getAppQrcode();
      if (res && res.code === 0) {
        console.log("qrcode", JSON.parse(res.data).id);
        this.curPoiQRcode = `${process.env.VUE_APP_QRCODE_URL}?${params}&id=${
          JSON.parse(res.data).id
        }`;
        console.log("process.env.VUE_APP_QRCODE_URL", this.curPoiQRcode);
      }
    },
    // 数据转化
    formaData(data) {
      let arr = [];
      data.forEach(item => {
        let obj = {};
        obj.id = item.nodeId;
        obj.name = item.name;
        obj.buildId = item.buildId;
        obj.floor = item.floor;
        obj.polygonId = item.polygonId;
        arr.push(obj);
      });
      return arr;
    },
    // 获取二维码
    async getAppQrcode() {
      let params = { buildId: this.buildInfo.buildId, n: this.poi["poiId"] };
      if (this.baseSettingInfo.basiSetting?.codeType === 1) {
        params.screen = this.$store.state.app.deviInfo.mac;
      }
      try {
        let res = await this.$apis.third.getQcodeMapParamId({
          params: JSON.stringify(params)
        });
        console.log("res", res);
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    // 改变选中index
    async changeIndex(item, index) {
      if (this.dataIndex === index) return;
      this.dataIndex = index;
      // this.$emit('changeIndex', item, index);
      this.$emit("clickItem", item, index);
      let params = this.$utils.urlEncode(
        {
          b: this.buildInfo.buildId,
          n: this.dataList[this.dataIndex]["poiId"],
          e: this.envCode
        },
        false
      );
      let qrcode = await this.getAppQrcode(this.appid, params);
      this.curPoiQRcode = qrcode;
    },
    // 去这里
    gotoHere(poiData) {
      let point = poiData;
      point.beaconId = point.id;
      point.poiName = point.name;
      point.axisX = point.x;
      point.axisY = point.y;
      this.$emit("showSelectPoint", point);
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {
  .wrap-poi-search-result {
    position: relative;
    height: 100%;
    width: 100%;
    background: url("/images/preloader/rect2.png") no-repeat;
    background-size: 100% 100%;
    padding: 45px 20px 40px 33px;
    box-sizing: border-box;
    .poi-list {
      height: calc(100% - 100px);
      overflow-y: auto;
      color: $color-white;
      .poi-li {
        height: 100px;
        padding: 10px;
        box-sizing: border-box;
        background: $color-opacity-primary;
        display: flex;
        align-items: center;
        border-radius: 10px;
        margin: 0 0 20px 0;
        .number {
          width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 16px;
          border-radius: 50%;
          background: $color-opacity-primary;
        }
        .text {
          flex: 1;
          text-align: left;
          margin: 0 0 0 20px;
          .poiName {
            font-size: 18px;
            margin: 0 0 5px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            min-width: 0;
            // width: 260px;
          }
          .poiInfo {
            font-size: 16px;
          }
        }
        .btn {
          margin: 10px 0 0 0;
        }
        img {
          width: 120px;
        }
      }
      .active {
        background: $color-opacity-regular;
        .number {
          background: $color-opacity-regular;
        }
        .text {
          color: #21feaf;
        }
      }
    }
    .qrcode {
      height: 200px;
      padding: 15px;
      margin: 30px 0 0 0;
      box-sizing: border-box;
      display: flex;
      border: 1px solid #5480a7;
      border-radius: 20px;
      align-items: center;
      ::v-deep .el-icon-circle-close {
        color: #fff;
      }
      img {
        width: 120px;
        height: 120px;
        border-radius: 20px;
        margin: 0 20px 0 0;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .text1 {
          font-size: 14px;
          color: $color-white;
        }
        .text2 {
          font-size: 20px;
          color: $color-white;
          margin: 15px 0 40px 0;
        }
        .text3 {
          font-size: 14px;
          color: #ff2828;
        }
      }
    }
    .btn-close {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      margin: auto;
      width: 120px;
    }
  }
}

@media (orientation: portrait) {
  .popMarker-close {
    display: inline-block;
    position: absolute;
    right: -30px;
    top: -60px;
    font-size: 3.89vw;
    opacity: 0.5;
    // border: 1px solid #fff;
    // padding: 20px;
    // border-radius: 90px;
  }
  .wrap-poi-search-result {
    position: relative;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    .poi-list {
      padding: 57px;
      background-color: rgba(0, 0, 0, 0.4);
      height: 85%;
      overflow-y: auto;
      color: $color-white;
      display: flex;
      flex-wrap: wrap;
      border-radius: 14px;
      .poi-li {
        font-size: 46px;
        width: 48%;
        height: 185px;
        padding: 44px;
        box-sizing: border-box;
        color: #fff;
        background: rgb(67, 92, 104);
        display: flex;
        align-items: center;
        border-radius: 14px;
        margin: 0 0 40px 0;
        display: flex;
        justify-content: space-between;
        .poiName {
          p {
            padding: 0;
            margin: 0;
            text-align: left;
          }
        }
        .btn {
          margin: 10px 0 0 0;
        }
        img {
          width: 11.11vw;
        }
      }
      .poi-li:nth-of-type(odd) {
        margin-right: 60px;
      }
    }
    .qrcode {
      height: 200px;
      padding: 15px;
      margin: 30px 0 0 0;
      box-sizing: border-box;
      display: flex;
      border: 1px solid #5480a7;
      border-radius: 20px;
      align-items: center;
      ::v-deep .el-icon-circle-close {
        color: #fff;
      }
      img {
        width: 120px;
        height: 120px;
        border-radius: 20px;
        margin: 0 20px 0 0;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .text1 {
          font-size: 14px;
          color: $color-white;
        }
        .text2 {
          font-size: 20px;
          color: $color-white;
          margin: 15px 0 40px 0;
        }
        .text3 {
          font-size: 14px;
          color: #ff2828;
        }
      }
    }
    .btn-close {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      margin: auto;
      width: 120px;
    }
  }
}
</style>
